import React, {useEffect} from 'react';
import style from './StockDashboard.module.css';
import StockMovers from './StockMovers/StockMovers';

const StockDashboard = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        //eslint-disable-next-line
    }, [])

    return (
        <div className={style.dashboardContainer}>
            <div className="container">
               <StockMovers />
            </div>
        </div>
    )
}

export default StockDashboard;
